module.exports = __webpack_public_path__ + "/db72e9dccd53c6ba3b6a2d466bc191a9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/Google_integration_icon.svg
 ** module id = 1105
 ** module chunks = 0
 **/